import {
  EyeIcon,
  PencilSquareIcon,
  TrashIcon
} from '@heroicons/react/24/outline'
import PromptModal from '../../../../common/PromptModal'
import { useRef } from 'react'
import { Flex, IconButton, useDisclosure } from '@chakra-ui/react'

interface Props {
  visitId: string
  onVisitSelect: (id: string) => void
  onVisitEdit: (id: string) => void
  onVisitDelete: (id: string, reason?: string) => void
}

export default function VisitActions({
  visitId,
  onVisitSelect,
  onVisitEdit,
  onVisitDelete
}: Props) {
  const cancelRef = useRef<any>()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const handleVisitSelect = () => {
    onVisitSelect(visitId)
  }

  const handleVisitEdit = () => {
    onVisitEdit(visitId)
  }

  const handleVisitDeleteClick = () => {
    onOpen()
  }

  const handleVisitDelete = (reason: string) => {
    onVisitDelete(visitId, reason)
    onClose()
  }

  return (
    <Flex justify="flex-end" gap={0.5}>
      <IconButton
        aria-label="View visit"
        icon={<EyeIcon style={{ width: '18px', height: '18px' }} />}
        size="sm"
        variant="ghost"
        colorScheme="gray"
        onClick={handleVisitSelect}
      />
      <IconButton
        aria-label="Edit visit"
        icon={<PencilSquareIcon style={{ width: '18px', height: '18px' }} />}
        size="sm"
        variant="ghost"
        colorScheme="gray"
        onClick={handleVisitEdit}
      />
      <PromptModal
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={handleVisitDelete}
        cancelRef={cancelRef}
      />
      <IconButton
        aria-label="Void visit"
        icon={<TrashIcon style={{ width: '18px', height: '18px' }} />}
        size="sm"
        variant="ghost"
        colorScheme="gray"
        onClick={handleVisitDeleteClick}
      />
    </Flex>
  )
}
